import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox } from '@els/els-react--checkbox';
import HoverTooltip from '@Components/HoverTooltip';
import { ButtonWithIcon } from '@els/els-react--button';
import { noop } from 'lodash/noop';
import { TooltipConstants } from '@Components/InfoTooltip';

import ProcessOptions from './ProcessOptions';

import './AdvancedContent.scss';

function AdvancedContent({ advancedContentDatabase, toggleAdvancedContentDatabase, advancedValidationMessage, ...props }) {
  return (
    <>
      <div
        className={classnames([
          'create-alert-dialog-section create-alert-dialog-section-advanced-content',
          { invalid: advancedValidationMessage },
        ])}>
        <div className="create-alert-dialog-section-label create-alert-dialog-flex-row">
          ADVANCED ALERT CONTENT:
          <HoverTooltip
            width="25rem"
            id={TooltipConstants.ids.AlertCreateDialog}
            placement="top-end"
            tooltip={`
            <ul class="info-tooltip-content-list">
              <li class="info-tooltip-content-list-item">
                Advanced alert content is only available for Reaxys content. The email will contain a preview of alert results as defined by the
                settings chosen:
              </li>
              <li class="info-tooltip-content-list-item bullet-dot">Title and bibliographic information</li>
              <li class="info-tooltip-content-list-item bullet-dot">
                Abstract: option to include the full abstract or partial abstract (first 5 lines) depending on preference
              </li>
              <li class="info-tooltip-content-list-item bullet-dot">Hit details: this will be dependent on your query e.g.</li>
              <li class="info-tooltip-content-list-item">
                <ul class="info-tooltip-content-list init-counter">
                  <li class="info-tooltip-content-list-item bullet-counter">
                    if you carried out a text-based search, your hit details will be the related keywords
                  </li>
                  <li class="info-tooltip-content-list-item bullet-counter">
                    if you searched for a reaction, the hit details will be the relevant reactions (max. 3 presented in the email)
                  </li>
                </ul>
              </li>
              <li class="info-tooltip-content-list-item">
                (Note: the number of hit substances, reactions and targets presented in the email is restricted to 3 in order to manage the email
                size)
              </li>
            </ul>
            `}>
            <ButtonWithIcon
              iconOnly
              type="link"
              linkIconSize="s"
              size="small"
              data-e2e="info-tooltip-alert-advanced-content"
              className="u-els-margin-left-1o2"
              e2eName="info-tooltip-alert-advanced-content"
              sprite="InformationOutlineCircle"
              onClick={() => noop()}
              a11y={{ name: 'Alert info', description: 'Alert information' }}>
              alert info
            </ButtonWithIcon>
          </HoverTooltip>
        </div>
        <div className="create-alert-dialog-row">
          <div className="create-alert-dialog-column-label">From databases:</div>
          <div className="create-alert-dialog-column-content">
            <Checkbox
              label={advancedContentDatabase.label}
              onChange={toggleAdvancedContentDatabase}
              checked={advancedContentDatabase.checked}
              data-e2e="alert-dialog-database"
              disabled={advancedContentDatabase.disabled}
              className="create-alert-dialog-database"
            />
          </div>
        </div>
        <ProcessOptions {...props} />
      </div>
      {advancedValidationMessage && (
        <div role="alert" className="create-alert-dialog-validation-message">
          {advancedValidationMessage}
        </div>
      )}
    </>
  );
}

AdvancedContent.propTypes = {
  advancedContentDatabase: PropTypes.object.isRequired,
  toggleAdvancedContentDatabase: PropTypes.func.isRequired,
  advancedValidationMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default AdvancedContent;
